import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { profileMenuItems } from 'src/layout/components/LinksList/config';
import { AccountForProfile } from 'src/svg/Accounts';
import { Arrow } from 'src/svg/Arrows';

interface HeadProps {
  isTopDrawerOpen: boolean;
}

export const Head: FC<HeadProps> = ({ isTopDrawerOpen }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentTab = profileMenuItems.find((el) => location.pathname.includes(el.route));

  return (
    <div className="flex items-center w-full py-2.5 px-6">
      <div className="mr-2.5">
        {currentTab ? (
          <currentTab.Icon fill="var(--as_link_active)" />
        ) : (
          <AccountForProfile fill="var(--as_link_active)" />
        )}
      </div>
      <p className="text-as_link_active">{t(`${currentTab?.content}`)}</p>
      <Arrow
        fill="var(--as_link_active)"
        className={classNames(
          'ml-auto w-6 stroke-[3px] transition-transform',
          isTopDrawerOpen && 'opened'
        )}
      />
    </div>
  );
};
